import dayjs from "dayjs";

/**
 * 날짜와 구분자를 받아 UTC 시간으로 변환하는 함수
 * @param {string|Date|null} date - 변환할 날짜
 * @param {'start'|'end'} type - 시작일자 또는 종료일자 구분
 * @param {boolean} useDefault - 기본값 사용 여부 (default: true)
 * @returns {string|null} UTC 시간 문자열 또는 null
 */
export const convertToUTCDateTime = (date, type = "start", useDefault = true) => {
    try {
        // date가 없을 경우
        if (!date) {
            return useDefault
                ? type === "start"
                    ? dayjs("1970-01-01").startOf("day").utc().format()
                    : dayjs("9999-12-31").endOf("day").utc().format()
                : null;
        }

        const d = dayjs(date);

        if (!d.isValid()) {
            return useDefault
                ? type === "start"
                    ? dayjs("1970-01-01").startOf("day").utc().format()
                    : dayjs("9999-12-31").endOf("day").utc().format()
                : null;
        }

        return type === "start" ? d.startOf("day").utc().format() : d.endOf("day").utc().format();
    } catch (error) {
        console.error("Date conversion error:", error);
        return useDefault
            ? type === "start"
                ? dayjs("1970-01-01").startOf("day").utc().format()
                : dayjs("9999-12-31").endOf("day").utc().format()
            : null;
    }
};
